<template>
  <div class="m-invoiceDetails--container">
    <span v-if="getFullName !== ''">{{ getFullName }}<br></span>
    <span v-if="address1">{{address1}}<br></span>
    <span v-if="address2">{{address2}}<br></span>
    <span v-if="city">{{city}}<br></span>
    <span v-if="state">{{state}},</span>
    <span v-if="postcode">{{postcode}}<br></span>
    <span v-if="selectedCountryName">{{selectedCountryName}}<br></span>
    <ToggleText faIconClass="fas fa-edit" text="Edit address" v-on:toggleEditable="$emit('toggleEditable')"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { isoCountries } from '../../store/modules/countrylist'
import ToggleText from '../atoms/ToggleText.vue'

export default {
  computed: mapState({
    firstName: state => state.cart.firstName,
    lastName: state => state.cart.lastName,
    address1: state => state.cart.address1,
    address2: state => state.cart.address2,
    city: state => state.cart.city,
    state: state => state.cart.state,
    postcode: state => state.cart.postcode,
    countryCode: state => state.cart.countryCode,
    getFullName () {
      let fullName = ''
      if (this.firstName !== '' && this.lastName !== '') {
        fullName = this.firstName + ', ' + this.lastName
      } else if (this.firstName !== '') {
        fullName = this.firstName
      } else if (this.lastName !== '') {
        fullName = this.lastName
      }
      return fullName
    }
  }),
  components: { ToggleText },
  data () {
    return {
      countries: isoCountries,
      selectedCountryName: ''
    }
  },
  created () {
    this.countries.find(country => {
      if (country.code === this.countryCode) {
        this.selectedCountryName = country.name
      }
    })
  }
}

</script>



// WEBPACK FOOTER //
// InvoiceDetails.vue?222d0c3b